import Castform from './Castform';
import image from './preview.png';

export const Image = image;
export default Castform;
